import React from 'react';
import LucideIcon from '../LucideIcon';

interface ChoiceCardProps {
  icon: string;
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const ChoiceCard: React.FC<ChoiceCardProps> = ({ icon, title, description, selected, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="card-live"
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 14,
      width: '100%',
      textAlign: 'left',
      padding: 18,
      borderRadius: 12,
      border: selected ? '2px solid var(--ember)' : '1px solid var(--border)',
      background: selected ? 'var(--ember-soft)' : 'var(--surface)',
      cursor: 'pointer',
      font: 'inherit',
    }}
  >
    <span style={{ color: 'var(--ember-strong)', flex: '0 0 auto', marginTop: 2 }}>
      <LucideIcon name={icon} size={20} />
    </span>
    <span style={{ flex: 1, minWidth: 0 }}>
      <span className="ws-display" style={{ display: 'block', fontSize: 14.5, fontWeight: 700, color: 'var(--text-primary)' }}>{title}</span>
      <span style={{ display: 'block', marginTop: 3, fontSize: 12.5, lineHeight: 1.5, color: 'var(--text-tertiary)' }}>{description}</span>
    </span>
    <span
      style={{
        flex: '0 0 auto',
        width: 18,
        height: 18,
        borderRadius: '50%',
        border: selected ? 'none' : '1.5px solid var(--border-strong)',
        background: selected ? 'var(--ember)' : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {selected && <span style={{ color: 'white', display: 'flex' }}><LucideIcon name="Check" size={12} /></span>}
    </span>
  </button>
);

export default ChoiceCard;
